import { render, staticRenderFns } from "./PanelPlaceholder.vue?vue&type=template&id=18d3ff4c&scoped=true&"
import script from "./PanelPlaceholder.vue?vue&type=script&lang=js&"
export * from "./PanelPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./PanelPlaceholder.vue?vue&type=style&index=0&id=18d3ff4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d3ff4c",
  null
  
)

export default component.exports